import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import './AuthOverlay.css';

const AuthOverlay = (): JSX.Element => {
    const { t } = useTranslation();
    const { login, isAuthenticating, loginError } = useAuth();

    const handleSignIn = () => {
        login();
    };

    return (
        <div
            className="auth-overlay"
            role="dialog"
            aria-modal="true"
            aria-label={t('Please sign in to the KoALA Questionnaire Editor')}
        >
            <div className="auth-card">
                <h1>{t('Please sign in to the KoALA Questionnaire Editor')}</h1>
                <button type="button" className="auth-submit" onClick={handleSignIn} disabled={isAuthenticating}>
                    {isAuthenticating ? t('Redirecting…') : t('Sign in')}
                </button>
                <p className="auth-helper">{t('You will be redirected to finish signing in securely.')}</p>
                {loginError && <p className="auth-error">{loginError}</p>}
            </div>
        </div>
    );
};

export default AuthOverlay;
